<template lang="pug">
	div.container-fluid.pt-2
		div.card
			.card-body
				.row
					.col.text-left
						.input-group
							.input-group-append
								button.btn.btn-primary(@click="anterior()")
									span.fa.fa-caret-left.mr-2
								button.btn.btn-primary(@click="siguiente()")
									span.fa.fa-caret-right.ml-2
							input-query(v-if="!filtro.usuario_ID && permisos.agenda_comercial_consultar_todos", placeholder="Filtra por usuario", url="/agenda-comercial/php/api/busca-agentes.php", :realtime="true", inputClass="form-control", @selected="seleccionaUsuario($event)")
							input.form-control(v-if="filtro.usuario_ID", :value="usuarioNombre", disabled="true")
							.input-group-append(v-if="filtro.usuario_ID")
								button.btn.btn-danger(@click="quitaUsuario")
									span.fa.fa-trash
					.col.text-center
						div(v-if="vista === 'mes'")
							h5
								b {{meses[fecha.getMonth()]}}, {{fecha.getFullYear()}}
						div(v-if="vista === 'semana'")
							h5
								b {{fechaInicioSemana | moment('DD-MM-YYYY')}} a {{new Date(fechaInicioSemana.getTime() + 518400000) | moment('DD-MM-YYYY')}}
						div(v-if="vista === 'dia'")
							h5
								b {{fecha | moment('DD-MM-YYYY')}}
					.col.text-right
						.btn-group
							button.btn.btn-sm(:class="(vista === 'mes') ? 'btn-primary' : ''", @click="setVista('mes')") Mes
							button.btn.btn-sm(:class="(vista === 'semana') ? 'btn-primary' : ''", @click="setVista('semana')") Semana
							button.btn.btn-sm(:class="(vista === 'dia') ? 'btn-primary' : ''", @click="setVista('dia')") Día
							button.btn.btn-sm(:class="(vista === 'agenda') ? 'btn-primary' : ''", @click="setVista('agenda')") Agenda
			vista-mes(@actualizar="getEventos", @editar="abreEditor($event)", :entradas="entradas", v-if="vista === 'mes'", :fecha.sync="fecha", @verSemana="verSemana($event)", @verDia="verDia($event)")
			vista-semana(@actualizar="getEventos", @editar="abreEditor($event)", @verDia="verDia($event)", :entradas="entradas", v-if="vista === 'semana'", :fecha.sync="fecha")
			vista-semana(@actualizar="getEventos", @editar="abreEditor($event)", @verDia="verDia($event)", :entradas="entradas", v-if="vista === 'dia'", :fecha.sync="fecha", :dias="1")
			editor-entradas(@saved="getEventos", @cerrar="cerrarEditor" :id-registro="editor.ID_entrada", :fecha="editor.fecha", :hora="editor.hora", v-if="editor.ID_entrada")
</template>

<script>
import VistaMes from './mes'
import VistaSemana from './semana'
import { mapGetters } from 'vuex'
import axios from 'axios'
import EditorEntradas from '../editor/editor'

export default {
	components: {
		'vista-mes': VistaMes,
		'vista-semana': VistaSemana,
		'editor-entradas': EditorEntradas
	},
	data () {
		return {
			vista: 'semana',
			meses: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
			fecha: new Date(),
			filtro: {
				fechaIni: null,
				fechaFin: null,
				usuario_ID: null
			},
			usuarioNombre: null,
			listaEntradas: [],
			editor: {
				ID_entrada: null,
				fecha: null,
				hora: null
			}
		}
	},
	created () {
		this.getEventos()
	},
	computed: {
		...mapGetters({
			'permisos': 'permisos/permisos',
			'usuario': 'session/usuario'
		}),
		fechaInicioMes () {
			const fecha = new Date(this.fecha.getTime())
			fecha.setDate(1)
			fecha.setHours(0)
			fecha.setMinutes(0)
			fecha.setSeconds(0)
			return fecha
		},

		fechaFinMes () {
			const fecha = new Date(this.fecha.getTime())
			fecha.setDate(1)
			fecha.setHours(0)
			fecha.setMinutes(0)
			fecha.setSeconds(0)
			fecha.setMonth(fecha.getMonth() + 1)
			fecha.setDate(fecha.getDate() - 1)
			return fecha
		},

		fechaInicioSemana () {
			if (this.dias === 1) {
				return new Date(this.fecha.getTime())
			}

			const ahora = this.fecha
			const offset = (ahora.getDay() === 0) ? 6 : ahora.getDay() - 1

			const fecha = new Date(ahora.getTime())
			fecha.setDate(fecha.getDate() - offset)
			fecha.setHours(0)
			fecha.setMinutes(0)
			fecha.setSeconds(0)
			return fecha
		},
		fechaFinSemana () {
			const ahora = this.fecha
			const offset = (ahora.getDay() === 0) ? 0 : 7 - ahora.getDay()

			const fecha = new Date(ahora.getTime())
			fecha.setDate(fecha.getDate() + offset)
			fecha.setHours(23)
			fecha.setMinutes(59)
			fecha.setSeconds(59)
			return fecha
		},

		fechaInicioDia () {
			const fecha = new Date(this.fecha.getTime())
			fecha.setHours(0)
			fecha.setMinutes(0)
			fecha.setSeconds(0)
			return fecha
		},

		fechaFinDia () {
			const fecha = new Date(this.fecha.getTime())
			fecha.setHours(23)
			fecha.setMinutes(59)
			fecha.setSeconds(59)
			return fecha
		},

		entradas () {
			const arr = []

			for (let i = 0; i < this.listaEntradas.length; i++) {
				this.listaEntradas[i].fechaIni = new Date(this.listaEntradas[i].fecha_inicio_contacto * 1000)
				this.listaEntradas[i].fechaFin = new Date(this.listaEntradas[i].fecha_fin_contacto * 1000)
				this.listaEntradas[i].bgColor = (!this.listaEntradas[i].bgColor) ? 'darkred' : this.listaEntradas[i].bgColor
				this.listaEntradas[i].textColor = (!this.listaEntradas[i].textColor) ? 'white' : this.listaEntradas[i].textColor
				if (!this.listaEntradas[i].cancelada) {
					arr.push(this.listaEntradas[i])
				}
			}

			return arr
		}
	},
	methods: {
		setVista (vista) {
			this.fecha = new Date()
			this.vista = vista
			this.getEventos()
		},
		getEventos () {
			if (this.vista === 'mes') {
				this.filtro.fechaIni = this.fechaInicioMes
				this.filtro.fechaFin = this.fechaFinMes
			} else if (this.vista === 'semana') {
				this.filtro.fechaIni = this.fechaInicioSemana
				this.filtro.fechaFin = this.fechaFinSemana
			} else if (this.vista === 'dia') {
				this.filtro.fechaIni = this.fechaInicioDia
				this.filtro.fechaFin = this.fechaFinDia
			} else {
				return
			}

			this.filtro.fechaIni = Math.round(this.filtro.fechaIni.getTime() / 1000)
			this.filtro.fechaFin = Math.round(this.filtro.fechaFin.getTime() / 1000)
			axios.post('/agenda-comercial/php/api/busca-entradas.php', this.filtro)
				.then(res => {
					this.listaEntradas = res.data.entradas
				})
				.catch(this.$responseError)
		},
		abreEditor (datos) {
			this.editor = datos
		},

		cerrarEditor () {
			this.editor = {
				ID_entrada: null,
				fecha: null,
				hora: null
			}
		},

		siguiente () {
			if (this.vista === 'mes') {
				this.fecha.setMonth(this.fecha.getMonth() + 1)
				this.fecha = new Date(this.fecha.getTime())
			} else if (this.vista === 'semana') {
				this.fecha.setDate(this.fecha.getDate() + 7)
				this.fecha = new Date(this.fecha.getTime())
			} else if (this.vista === 'dia') {
				this.fecha.setDate(this.fecha.getDate() + 1)
				this.fecha = new Date(this.fecha.getTime())
			}
			this.getEventos()
			this.$forceUpdate()
		},
		anterior () {
			if (this.vista === 'mes') {
				this.fecha.setMonth(this.fecha.getMonth() - 1)
				this.fecha = new Date(this.fecha.getTime())
			} else if (this.vista === 'semana') {
				this.fecha.setDate(this.fecha.getDate() - 7)
				this.fecha = new Date(this.fecha.getTime())
			} else if (this.vista === 'dia') {
				this.fecha.setDate(this.fecha.getDate() - 1)
				this.fecha = new Date(this.fecha.getTime())
			}
			this.getEventos()
			this.$forceUpdate()
		},

		verDia (fecha) {
			this.fecha = new Date(fecha.getTime())
			this.vista = 'dia'
		},

		verSemana (fecha) {
			this.fecha = new Date(fecha.getTime())
			this.vista = 'semana'
		},

		seleccionaUsuario (ev) {
			this.filtro.usuario_ID = ev.datos.ID
			this.usuarioNombre = ev.texto
			this.getEventos()
		},
		quitaUsuario () {
			this.filtro.usuario_ID = null
			this.usuarioNombre = null
			this.getEventos()
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/modulos/agenda-comercial/vue/componentes/calendario/calendario.vue